// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2sgMM","btwb":"Logo_btwb__1il2J"};